const slides = [
    {
        text: 'holistic well-being',
        media: 'Tyler_Krenz',
        type: 'image',
        desktop: {
            offset: 15,
            degree: -45,
        },
        mobile: {
            offset: 100,
            degree: -45,
        },
        story: {
            id: 1
        }
    }, {
        text: 'belonging',
        media: 'Shaila_Mehta',
        type: 'image',
        desktop: {
            offset: 5,
            degree: 70
        },
        mobile: {
            offset: 0,
            degree: 50
        },
        story: {
            id: 2
        }
    }, {
        text: 'authentic connection & trust',
        media: 'Donald_Brouwer',
        type: 'image',
        desktop: {
            offset: 90,
            degree: 105
        },
        mobile: {
            offset: 95,
            degree: 5
        },
        story: {
            id: 3
        }
    }, {
        text: `award-winning culture`,
        media: 'Award_Winning',
        type: 'image',
        desktop: {
            offset: 70,
            degree: -80
        },
        mobile: {
            offset: 240,
            degree: 15
        },
        story: {
            id: ['play', 4]
        }
    }
]

export default {
    student: slides,
    experienced: slides,
}